import React, { useState,useEffect } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  DashboardOutlined,
  CloudUploadOutlined,
  UserOutlined,
  LogoutOutlined,
  DatabaseOutlined,
  MoneyCollectOutlined,
  AreaChartOutlined,
  ArrowUpOutlined,
  MoneyCollectTwoTone,
  BookOutlined,
  ToolOutlined
} from '@ant-design/icons';
import { 
  Button, 
  Layout, 
  Menu, 
  theme, 
  Space, 
  Avatar, 
  Dropdown, 
  Typography, 
  Card, 
  Tooltip 
} from 'antd';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/authContext';

const { Header, Sider, Content } = Layout;
const { Title, Text, Link } = Typography;

const Dashboard = ({component}) => {
  const [collapsed, setCollapsed] = useState(true);
  const [activeKey, setActiveKey] = useState('');
  const {logout,roles} = useAuth()
  const navigate = useNavigate()
  const isAdminOrSales = roles.includes("ADMIN") || roles.includes("SALES");

  const [showScrollToTop, setShowScrollToTop] = useState(false);

  const handleScroll = () => {
    const table = document.getElementById('table');
    // console.log(table);
    
    if (table && table.scrollTop > 300) {
      setShowScrollToTop(true);
    } else {
      setShowScrollToTop(false);
    }
  };

  const scrollToTop = () => {
    const table = document.getElementById('table');
    if (table) {
      table.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const table = document.getElementById('table');
    if (table) {
      table.addEventListener('scroll', handleScroll);
      return () => {
        table.removeEventListener('scroll', handleScroll);
      };
    }
  }, []);


  const sidebarMenu = isAdminOrSales ? [
    {
      key: '',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: 'leads',
      icon: <DatabaseOutlined />,
      label: 'Leads',
    },
    // {
    //   key: 'conversions',
    //   icon: <MoneyCollectOutlined />,
    //   label: 'Conversions',
    // },
    {
      key: 'conversions_v1',
      icon: <BookOutlined />,
      label: 'Conversions_v1',
    },
    {
      key: 'jobs',
      icon: <ToolOutlined />,
      label: 'Job Management',
    },
    {
      key: 'analytics',
      icon: <AreaChartOutlined />,
      label: 'Analytics',
    },
    {
      key: 'products',
      icon: <CloudUploadOutlined />,
      label: 'Products',
    },
    {
      key: 'user',
      icon: <UserOutlined />,
      label: 'Users',
    }
  ] : [
    {
      key: '',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: 'jobs',
      icon: <ToolOutlined />,
      label: 'Job Management',
    },
  ];


  const profileMenu = [
    // {
    //   key: 'profile',
    //   label: 'Profile',
    //   icon: <UserOutlined />,
    //   onClick: () => {},
    // },
    {
      key: 'logout',
      label: 'Logout',
      icon: <LogoutOutlined />,
      danger: true,
      onClick: () => {logout()
        window.location.reload()
      },
    }
  ];
  


  return (
    <div className="flex w-full h-screen overflow-hidden bg-gray-50">
      {/* Sidebar */}
      <div 
        className={`
          bg-white border-r border-gray-200 
          transition-all duration-300 ease-in-out
          ${collapsed ? 'w-20' : 'w-64'}
        `}
      >
        {/* Logo Area */}
        <div className="flex justify-center items-center h-20 border-b border-gray-200">
          <img 
            src="https://5.imimg.com/data5/SELLER/Logo/2024/10/459711976/MT/YZ/YE/160654475/printverse-logo-120x120.jpg" 
            alt="Company Logo" 
            className={`
              transition-all duration-300
              ${collapsed ? 'w-10' : 'w-16'}
            `}
          />
        </div>

        {/* Navigation Menu */}
        <nav className="p-4">
          {sidebarMenu.map(item => (
            <div 
              key={item.key}
              className={`
                flex items-center p-3 mb-2 rounded-lg cursor-pointer
                transition-all duration-300 ease-in-out
                ${activeKey === item.key 
                  ? 'bg-blue-500 text-white' 
                  : 'hover:bg-gray-100 text-gray-600'}
              `}
              onClick={() => {
                setActiveKey(item.key) 
                navigate(`/${item.key}`)
            }}
            >
              <span className="text-xl mr-3">{item.icon}</span>
              {!collapsed && <span>{item.label}</span>}
            </div>
          ))}
        </nav>
      </div>

      {/* Main Content Area */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        {showScrollToTop && (
        <Button
          type="primary"
          shape="circle"
          icon={<ArrowUpOutlined />}
          size="large"
          style={{
            position: 'fixed',
            bottom: '20px',
            right: '20px',
            zIndex: 1000,
          }}
          onClick={scrollToTop}
        />
      )}
        <header className="bg-white shadow-sm h-20 flex items-center justify-between px-6">
          <Tooltip title={collapsed ? "Expand Menu" : "Collapse Menu"}>
            <Button 
              type="text" 
              onClick={() => setCollapsed(!collapsed)}
              className="text-gray-600 hover:bg-gray-100"
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </Button>
          </Tooltip>

          <div className="flex items-center space-x-4">
            <Dropdown 
              menu={{ items: profileMenu }} 
              placement="bottomRight"
            >
              <Avatar 
                className="cursor-pointer bg-blue-500 hover:bg-blue-600"
                icon={<UserOutlined />} 
              />
            </Dropdown>
          </div>
        </header>

        {/* Main Content */}
        <main id="table" className="flex-1 p-6 overflow-y-auto bg-gray-50">
          {component ? component :<div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                title: "Company Details",
                content: (
                  <div>
                    <Text strong className="block mb-2">Company Name</Text>
                    <Text code>Printverse Pvt Ltd</Text>
                  </div>
                )
              },
              {
                title: "Location",
                content: (
                  <div>
                    <Text strong className="block mb-2">Address</Text>
                    <Text code>1B No. 20, Juna Tukoganj, Opposite Rambag Petrol Pump, Near Burhani Enterprise, Indore - 452007, Madhya Pradesh, India</Text>
                    <Link 
                      href="#" 
                      className="block mt-2 text-blue-500 hover:text-blue-600"
                    >
                      View on Map
                    </Link>
                  </div>
                )
              },
              {
                title: "Bank Details",
                content: (
                  <div>
                    <Text strong className="block mb-2">Bank Name</Text>
                    <Text code>ICICI Bank</Text>
                    <Text strong className="block mt-2 mb-2">Account No.</Text>
                    <Text code>987654321</Text>
                  </div>
                )
              }
            ].map((section, index) => (
              <Card 
                key={index}
                className="bg-white border border-gray-200 rounded-lg shadow-sm hover:shadow-md transition-all"
              >
                <Title 
                  level={4} 
                  className="mb-4 text-gray-800 border-b pb-2"
                >
                  {section.title}
                </Title>
                {section.content}
              </Card>
            ))}
          </div>}
        </main>

        {/* Footer */}
        <footer className="bg-white border-t border-gray-200 p-4 text-center text-gray-500">
          © {new Date().getFullYear()} <a className='text-blue-500 font-bold italic' href='https://synquic.com'>Synquic</a>. All Rights Reserved.
        </footer>
      </div>
    </div>
  );
};

export default Dashboard;